export const PRODUCT_SEARCH_LIMIT = 20
